// extracted by mini-css-extract-plugin
module.exports = {"partner":"Partner_partner__2gnEX","partner__img__horizontal":"Partner_partner__img__horizontal__3E6NX","partner__img":"Partner_partner__img__3_0us"};